import { lazy } from 'react';

const AppContainer = lazy(() => import('components/App/AppContainer'));

export default AppContainer;
